<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <b-form-select v-model="form.satellite_church_id" :options="options"></b-form-select>
          </CCol> 
          </CRow>
       
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Update</CButton>
        
        </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import satelite from '@/services/satelitechurch'
import member from '@/services/member';

import moment from 'moment';

export default {
name: 'satelitemodal',
  data () {
    return {
    show: false,
    title: 'Default Title',
    mode: '',
    datas:[],
    form:{
      uuid:'',
      firstname:'',
      lastname:'',
      // dob:'',
      email:'',
      satellite_church_id:'',
    },
    options:[],
   
    }
  },
  
  mounted (){
    //  this.load()

    //   EventBus.$on('PAGE_UPDATE', (data) => {
    //   if(data){
    //       this.load();
    //   }
    // });
   },
  created () {
    var self = this; 
      EventBus.$on('OPEN_MODAL_MEMBER_SATELITE', (params) => {
      if(params.data){
      member.getMemberbyID(params.data)
      .then(res => {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = params.data;
      self.form.firstname = res.data.firstname;
      self.form.lastname = res.data.lastname;
      // self.form.dob = res.data.dob;
      self.form.email = res.data.email;
      self.form.satellite_church_id = res.data.satellite_church_id;

       }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
         }else{
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = "";
      self.form.firstname = "";
      self.form.lastname = "";
      // self.form.dob = "";
      self.form.email = "";
      self.form.satellite_church_id = "";
      
      }
      
    });
    this.form.uuid = this.$route.query.Pud
    this.options = []
    satelite.getSateliteChurch()
    .then(res => {
      for (let i=0; i <= res.data.length-1; i++){
        //alert
        this.options.push({text: res.data[i].name, value:res.data[i].id})
      }
    }).catch((er) =>{
      var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
    })
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
   update(id){
      this.show = false;
      member.updateMember(id, this.form)
      .then(res => {
        EventBus.$emit('PAGE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },

    //   load(){
    //   member.getMemberbyID(this.$route.query.Pud)
    //   .then(res => {
    //   this.datas =res

    //   if(this.datas.data.satellite_church_id === null){
    //     this.datas.data.satellite_church_id = ''
    //   }
    //   })  
    // },
    
   
  }
}
</script>

<style>

</style>